var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWriteJournals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "#C6BDFF",
    fillOpacity: 0.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.452 36.0126H29.1984V28.0782H34.452V22.8679H29.1984V20.2231C29.1984 17.2874 31.548 14.96 34.452 14.96H50.2392V33.3678L56.76 29.4006L63.36 33.3678V14.96H66C68.772 14.96 71.28 17.499 71.28 20.2231V57.1711C71.28 59.8953 68.772 62.4607 66 62.4607H34.452C31.68 62.4607 29.1984 59.9482 29.1984 57.1711V54.5263H34.452V49.2367H29.1984V41.3023H34.452V36.0126ZM13.2 59.8159H18.48V51.8815H13.2V46.5919H18.48V38.6574H13.2V33.3678H18.48V25.4334H23.76V33.3678H18.48V38.6574H23.76V46.5919H18.48V51.8815H23.76V59.8159H18.48V65.1055H23.76V67.7503H66V73.04H23.76C22.3597 73.04 21.0167 72.4827 20.0265 71.4907C19.0363 70.4987 18.48 69.1532 18.48 67.7503V65.1055H13.2V59.8159Z",
    fill: "#6956E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteJournals);
export default __webpack_public_path__ + "static/media/write_journals.12fdf85b06c3aa7a588331896134305e.svg";
export { ForwardRef as ReactComponent };